import { Link } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { allowedFileFormats } from './constants/globals';
import moment from 'moment';

export const fetchLocaleFromLocalStorage = () => {
  return localStorage.getItem('locale');
};

export const setMessage = (msg, tagId, msgId) => async (dispatch) => {
  document.querySelector(tagId).classList.add('alert-danger');
  document.querySelector(msgId).style.color = 'red';
  document.querySelector(msgId).innerHTML = '<h5>' + msg + '</h5>';
};

export const changePaginationTextToSerbian = (obj, of) => {
  return '' + obj.from + '-' + obj.to + of + obj.count;
};

export const formatDate = (date) => {
  return moment(date).format('DD.MM.YYYY.');
};

export const formatDateWithTooltip = (date) => {
  const tooltipTitle = moment(date).format('DD.MM.YYYY. HH:mm:ss');
  const dateFormat = moment(date).format('DD.MM.YYYY.');
  return (
    <Tooltip title={tooltipTitle} placement="top" arrow={true}>
      <div>{dateFormat}</div>
    </Tooltip>
  );
};

export const handleErrorMessage = (
  error,
  serverValidationMessage,
  clientValidationMessage
) => {
  return error
    ? error[serverValidationMessage]
    : clientValidationMessage !== ''
    ? clientValidationMessage
    : '';
};

export const addNewButton = (onClickAction, tooltpTitle) => {
  return (
    <Link id="addUser" onClick={onClickAction} to="#">
      <Tooltip title={tooltpTitle} placement="bottom" arrow={true}>
        <i className="fas fa-plus fa-2x" />
      </Tooltip>
    </Link>
  );
};

export const getUpdateValueItem = (list, id) => {
  return list.find((item) => item.id === id);
};

export const createNotification = (type, titleMessage, descriptionMessage) => {
  switch (type) {
    case 'info':
      NotificationManager.info(descriptionMessage, titleMessage, 3000);
      break;
    case 'success':
      NotificationManager.success(descriptionMessage, titleMessage, 3000);
      break;
    case 'warning':
      NotificationManager.warning(descriptionMessage, titleMessage, 3000);
      break;
    case 'error':
      NotificationManager.error(descriptionMessage, titleMessage, 3000);
      break;
    default:
      break;
  }
};
export const getUserNameAndSurname = (user) => {
  return user && user.firstName && user.lastName
    ? user.firstName + ' ' + user.lastName
    : '';
};

export const checkForUserRole = (roles, targetRoleId) => {
  return roles?.filter((role) => role.id === targetRoleId).length !== 0;
};

export const returnFileFormat = (documentName) => {
  let format = documentName.substring(
    documentName.lastIndexOf('.') + 1,
    documentName.length
  );
  
  return format;
};

export const checkFileFormat = (files) => {
  for (let i = 0; i < files.length; i++) {
    let format = returnFileFormat(files[i].name);
    console.log('format',format)
    if (!allowedFileFormats.includes(format?.toLowerCase())) {
      return true;
    }
  }
  return false;
};

export const getFilesForUpload = (files) => {
  const arrayLength = files.length;
  if (arrayLength !== 0) {
    let uploadedArray = [];
    for (let i = 0; i < arrayLength; i++) {
      uploadedArray.push(files[i]);
    }
    return uploadedArray;
  } else {
    return null;
  }
};

export const mailTrigger = ({ recipient, subject, body }) => {
  const emailBody = (body && body) || '';
  window.open(`mailto:${recipient}?subject=${subject}&body=${emailBody}`);
};

export const checkIfUserHasAutonomousProvince = (user) => {
  return (
    user?.kjsList?.filter(
      (kjsMunicipality) =>
        kjsMunicipality.municipality?.place?.autonomousProvince !== null
    ).length > 0
  );
};
